<template>
  <v-container
    class="mx-auto mt-10"
  >
    <div class="text-h3 text-center">
      {{isEditing ? 'Editar Proyecto' : 'Crear Proyecto'}}
    </div>
    <v-form
      ref="form"
      class="d-flex flex-column"
      v-model="valid"
      height=100%
    >
      <v-row>
        <v-col>
          <v-text-field
            v-model="project.name"
            :counter="255"
            label="Título del proyecto"
          ></v-text-field>
          <editor
            :initialValue="project.description"
            :options="{ hideModeSwitch: true }"
            outlined
            ref="toastuiEditor"
            initialEditType="wysiwyg"
            @change="onEditorChange"
            label="Ficha del proyecto"
            :key="'pjEditor'+editorKey"
            required
          />
        </v-col>
        <v-col>
          <v-row class="align-center">
            <v-col cols="4">
              <v-text-field
                v-model="project.profitsBeginQuantity"
                :rules="requiredRule"
                label="Plazo"
                type="number"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="8">
              <v-select
                v-model="project.profitsBeginTimePeriod"
                :items="measures"
                item-text="name"
                item-value="id"
                label="Rango"
                required
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="align-center">
            <v-col cols="8">
              <v-text-field
                v-model="estimatedReturn"
                :rules="requiredRule"
                prefix="%"
                label="Retorno estimado"
                type="number"
                required
              ></v-text-field>
            </v-col>
            <v-col cols="4">
              <v-select
                v-model="project.currency"
                :items="currencies"
                item-text="name"
                item-value="id"
                label="Moneda"
                required
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="align-center" >
            <v-card class="pa-2 cardColor" outlined width="100%">
              <images-card ref="portraitCard" idCard="portraitImage" @getCardInfo="addCardInfo" :multiple="false"  cardTitle="portrait" :preRegisteredValues="portrait" :key="portraitKey" />
            </v-card>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-for="(card,index) in cards" :key="index" class="pa-2">
        <Card @deleteThisCard="removeCard" :idCard="index" :cardTitleProp="(project.projectCards.length>0&&project.projectCards[index])?project.projectCards[index].name:''"  v-slot:default="slotProps"> 
          <component ref="cardComponents" :is="card" :idCard="index.toString()" @getCardInfo="addCardInfo" :cardTitle="slotProps.title" :preRegisteredValues="(project.projectCards.length>0)?project.projectCards[index]:undefined"/>
        </Card>
      </v-row>
      <v-row class="pa-2">
        <v-card width="100%">
          <v-card-text>
            <v-row align="center" justify="center">
              <v-col cols="4">
                <v-select :items="cardOptions" v-model="selectedCard" />
              </v-col>
              <v-col cols="2">
                <v-btn @click="addCard">Agregar tarjeta</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-row>
      <v-row
        class="justify-center mt-5"
      >
        <v-btn
          :disabled="!valid && !isSaving"
          color="success"
          class="mr-5"
          v-if="!isEditing"
          v-on:click="saveProject"
        >
          Crear
        </v-btn>
        <v-btn
          v-else
          color="success"
          class="mr-5"
          :disabled="isSaving"
          v-on:click="updateProject"
        >
          Editar
        </v-btn>
        
        
      </v-row>
    </v-form>
    
  </v-container>
</template>

<script>
import axios from 'axios'
import 'codemirror/lib/codemirror.css';
import '@toast-ui/editor/dist/toastui-editor.css';

import { Editor } from '@toast-ui/vue-editor';

export default {
  name: 'ProjectCreation',
  data() {
    return {
      project: {
        projectCards:[]
      },
      
      isSaving: false,
      isEditing: false,
      valid: true,
      requiredRule: [
        v => !!v || 'Este campo es obligatorio.'
      ],
      measures: [
        {
          id: 1,
          name: "Días"
        },
        {
          id: 7,
          name: "Semanas"
        },
        {
          id: 30,
          name: "Meses"
        },
        {
          id: 365,
          name: "Años"
        }
      ],

      portraitImage: null,
      portraitKey:0,
      portrait: undefined,
      currencies:[],
      slotProps:{},
      selectedCard:"",
      cards:[],
      cardOptions:[
        {
          text:"ImagesCard",
          value:"ImagesCard",
        },
        {
          text:"TextCard",
          value:"TextCard"
        },
        {
          text:"VideoCard",
          value:"VideoCard"
        },
        {
          text:"MapCard",
          value:"MapCard"
        }
      ],
      editorKey: 0
    }
  },
  components:{
    Card:()=>import('@/components/cards/Card.vue'),
    ImagesCard:()=>import('@/components/cards/ImagesCard.vue'),
    TextCard:()=>import('@/components/cards/TextCard.vue'),
    VideoCard:()=>import('@/components/cards/VideoCard.vue'),
    MapCard:()=>import('@/components/cards/MapCard.vue'),
    Editor,
  },
  beforeMount() {
    //Load existing project data if url param exists
    if(this.$route.params.id){
      this.isEditing= true
      this.$cf_api.getProjectEdit(this.$route.params.id).then(response=>{
        this.loadedProject = JSON.parse(JSON.stringify(response.data))
        this.project =JSON.parse(JSON.stringify(response.data))
        var portraitIndex= this.project.projectCards.findIndex(pjc=>pjc.cardType==0)
        var port = this.project.projectCards[portraitIndex]
        this.project.projectCards.splice(portraitIndex, 1)
        this.portrait=Object.assign({}, this.portrait,  {"projectCardId":port.projectCardId,"name":port.name, "imageSlide": [port.imageId], "cardType": port.cardType})
        this.portraitKey++
        this.project.projectCards.forEach(pjc=>{
          switch(pjc.cardType){
            case 1:
              this.cards.splice(this.cards.length,1,"ImagesCard")
              break;
            case 2:
              this.cards.splice(this.cards.length,1,"VideoCard")
              break;
            case 3:
              this.cards.splice(this.cards.length,1,"TextCard")
              break;
            case 4:
              this.cards.splice(this.cards.length,1,"MapCard")
              break;
          }
        })
        this.editorKey ++
      }).catch(()=>{
        this.$store.dispatch('setSnack', 'No tenés permiso para editar este proyecto.')
        this.$router.push('/admin/projects')
      })
    }
    this.$cf_api.getCurrencies().then(resp=>{
      for(var i=0; i< resp.data.length; i ++){
        this.currencies.splice(0, 1,  { id: resp.data[i].currencyIso, name:resp.data[i].symbol+resp.data[i].currencyIso})
      }     
    })
  }, 
  computed:{
    estimatedReturn:{
      get: function(){
        return +(this.project.estimatedReturn * 100).toFixed(4)
      },
      set: function(newValue){
        this.project.estimatedReturn = (newValue/100).toFixed(4);
      }
    },
    userRole(){
      return this.$store.getters.getUserRole
    }
  },
  methods: {
    onEditorChange() {
        this.project.description=this.$refs.toastuiEditor.invoke('getMarkdown');
    },
    loadData(name, callback) {
      axios.get(process.env.BASE_URL + `api/${name}.json`)
        .then(response => {
          callback(response.data);
        })
    },
    chooseFile() {
      document.getElementById("portrait").click()
    },
    addCard(){
      this.cards.splice(this.cards.length, 0, this.selectedCard)
      this.selectedCard=""
    },
    removeCard(id){
      this.cards.splice(id,1)
      if(this.isEditing){
        this.project.projectCards.splice(id,1)
      }
    },
    addCardInfo(e){
      if(this.isEditing){
        var cardIndex = this.project.projectCards.findIndex(pjc=> pjc.projectCardId === e.projectCardId)
        if(e.projectCardId!== undefined && cardIndex !== -1){
          this.project.projectCards[cardIndex] = e
        }else{
          this.project.projectCards.push(e)
        }
      } else {
        this.project.projectCards.push(e)
      }
    },
    addValidation(id,value){
      this.validCards[id]=value
    },
    updateProject(){
      this.isSaving = !this.isSaving
      // Verifico cambios en todas las tarjetas
      var cardsChanges = []
      this.$refs.portraitCard.emitCardInfo()
      if(this.$refs.cardComponents && this.$refs.cardComponents.length >0){
        this.$refs.cardComponents.forEach(c=>{
          c.emitCardInfo()
        })
        this.project.projectCards.forEach(pjc=>{
          var cardChanges = {}
          if(pjc.type===1){
            pjc.oldImage
          }
          if(pjc.projectCardId){
            cardChanges = this.checkChanges(pjc)
            if(Object.keys( cardChanges ).length>3){
              cardsChanges.push( cardChanges )
            }              
            
          }else {
            cardChanges = pjc
            cardChanges.action = 'add'
            cardsChanges.push( cardChanges )
          }
        })
      }
      var portraitChanges = this.checkChanges(this.project.projectCards[this.project.projectCards.findIndex(pjc=>pjc.cardType==0)])
      console.log('portraitChanges', portraitChanges)
      if(Object.keys( portraitChanges ).length>3){
        cardsChanges.push( portraitChanges )
      } 
      this.loadedProject.projectCards.forEach(lpjc=>{
        if(lpjc.cardType!==0 && this.project.projectCards.find(pjc=> pjc.projectCardId ===lpjc.projectCardId) === undefined){
          cardsChanges.push({projectCardId: lpjc.projectCardId, action:'remove'})
        }
      })
      if(this.valid) {
        var projectToUpdate = JSON.parse(JSON.stringify(this.project))
        delete projectToUpdate.projectCards
        //Verifico si hay cambios en el resto de los campos del proyecto y me quedo solo con los que contengan cambios
        var projectUpdate = Object.keys( projectToUpdate ).reduce( ( formData, field ) => {
          if ( projectToUpdate[ field ] !== this.loadedProject[ field ] ) {
            formData[ field ] = projectToUpdate[ field ];
          }
          return formData;
        }, {} )

        if(cardsChanges.length>0){
          projectUpdate.projectCards = cardsChanges
        }
        projectUpdate.projectId = parseInt(this.$route.params.id)
        if(Object.keys(projectUpdate).length > 1){
          this.$cf_api.patchProject(projectUpdate).then(()=>{
            this.$store.dispatch('setSnack', 'Se ha editado el proyecto correctamente.')
            this.$router.push('/admin/projects')
          }).catch(e=>{
            console.log('Error submitting new project edition: ',e)
            this.$store.dispatch('setSnack', 'Ha habido un error. Intentar nuevamente mas tarde.')
          })
        } else {
          this.$store.dispatch('setSnack', 'No se han detectado cambios en el proyecto.')
        }
        
        this.isSaving = !this.isSaving
      } else {
        this.$store.dispatch('setSnack', 'El formulario no esta completo!')
        setTimeout(()=>{this.isSaving = !this.isSaving},500)
      }
    },
    checkChanges(pjc){
      var cardLoaded = this.loadedProject.projectCards.find(lpjc=>lpjc.projectCardId === pjc.projectCardId)
      var cardChanges = {}
      cardLoaded.oldImageSlide = cardLoaded.imageSlide
      if(cardLoaded) {
        cardChanges= Object.keys( pjc ).reduce( ( formData, field ) => {
          if(cardLoaded[field] === null && pjc[field]===null){
            return formData
          } else if(cardLoaded[field] === null && pjc[field]!==null) {
            formData[field] = pjc[field]
            return formData
          } else if(cardLoaded[field] !== null && pjc[field]===null) {
            formData[field] = cardLoaded[field]
            return formData
          }
          if(typeof(pjc[field]) === 'object'){
            var different = !(pjc[field].length===cardLoaded[field].length)
            var i=0
            while( i < pjc[field].length && !different){
              if(pjc[field][i] !== cardLoaded[field][i]){
                different = true
              } else
                i++
            }
            if(different){
              formData[ field ] = pjc[ field ]
            }

          } else 
          if ( pjc[ field ] !== cardLoaded[ field ] ) {
            formData[ field ] = pjc[ field ];
          }
          return formData;
        }, {} )
        cardChanges.action = 'update'
        cardChanges.projectCardId = pjc.projectCardId
        cardChanges.cardType = pjc.cardType
      }
      return cardChanges
    },
    saveProject() {
      this.isSaving = !this.isSaving
      this.$refs.portraitCard.emitCardInfo()
      if(this.$refs.cardComponents){
        this.$refs.cardComponents.forEach(c=>{
          c.emitCardInfo()
        })
      }
      if(this.valid) {
        this.$cf_api.postProject({
          Name: this.project.name,
          Description: this.project.description,
          Currency: this.project.currency,
          EstimatedReturn: this.project.estimatedReturn,
          ProfitsBeginQuantity: parseInt(this.project.profitsBeginQuantity),
          ProfitsBeginTimePeriod: this.project.profitsBeginTimePeriod,
          ProjectCards: this.project.projectCards
        }).then(()=>{
          this.$store.dispatch('setSnack', 'Se ha creado el proyecto correctamente.')
          this.$router.push('/admin/projects')
        }).catch(e=>{
          console.log('Error submitting new project: ',e)
          this.$store.dispatch('setSnack', 'Ha habido un error. Intentar nuevamente mas tarde.')
        })
      } else {
        this.$store.dispatch('setSnack', 'El formulario no esta completo!')
        setTimeout(()=>{this.isSaving = !this.isSaving},500)
      }
    },
    getTitle(index,str){
      if(this.project.projectCards[index].name!==undefined){
        return this.project.projectCards[index].name
      } else{
        return str
      }
    },
    approveProject(){
      this.$cf_api.approveProject(this.$route.params.id).then(()=> {
        this.$store.dispatch('setSnack','El proyecto ha sido aprobado.')
        this.$router.go()
      })
    }
  }
}

</script>

<style scoped>
  .cardColor {
    background-color: rgba(255, 255, 255, 0.5) !important;
    border-color: white !important;
  }
</style>
